import React, {useCallback, useEffect, useState} from 'react';

import {useI18n} from '../../../../../../../data/hooks/i18nHooks';
import {useMyUserId} from '../../../../../../../data/hooks/sessionHooks';
import ContainedImage from '../../../../../../elements/ContainedImage';
import favoriteIcon from '../../../icons/favorite.png';
import favoritedIcon from '../../../icons/favorited.png';
import styles from '../BubbleMenu.module.scss';

const Favorite = props => {
    const {event, user} = props,
        i18n = useI18n(),
        myUserId = useMyUserId(),
        [favorited, setFavorited] = useState(false); // TODO: check if user is a favorite

    useEffect(() => {
        if (user.is_favorite != favorited) setFavorited(user.is_favorite);
    }, [user]);

    const handleToggleFavorite = useCallback(() => {
        setFavorited(!favorited);
        app.api.participants.toggleFavorite(user, !favorited, event?.id);
    }, [favorited]);

    if (!user) return null;
    if (user.user_id == myUserId) return null;

    return (
        <button type="button" onClick={handleToggleFavorite}>
            <span className={styles.label}>{i18n['label.startnetworking.favorite']}</span>
            <ContainedImage src={favorited ? favoritedIcon : favoriteIcon} color="white" />
        </button>
    );
};

export default Favorite;
